<template>
    <div>
        <dictionary-simple-table
        dictionary_link = "/product-altum-rooms"
        title = "Lista pokojów Altum"
        :numeral_text = "['pokoj', 'pokoje', 'pokoi']"
        :columns_title = "['name']"
        ></dictionary-simple-table>
    </div>
</template>

<script>
    import DictionarySimpleTable from './DictionarySimpleTable.vue';
    export default {
        components: {
            DictionarySimpleTable
        },
    }
</script>